import axios from 'axios'
import appConfig from '@/appconfig'
// import constant from '@constants/constant'

export const state = {
  cached: [],
  lenderId: getSavedLenderState('lenders.lenderId'),
  loanOfficerID: getSavedLoanOfficerIDState('loanOfficers.loanOfficerID'),
}

export const getters = {
  LoanOfficer: (state) => {
    return state.loanOfficer
  },
  loanOfficerID: (state) => {
    return state.loanOfficerID
  },
}

export const mutations = {
  SET_LOAN_OFFICER(state, loanOfficerDetails) {
    state.loanOfficer = loanOfficerDetails
    saveLoanOfficerId('loanOfficers.loanOfficerID', null)
  },
  SET_LOANOFFICER_ID(state, loanOfficerID) {
    state.loanOfficerID = loanOfficerID
    saveLoanOfficerId('loanOfficers.loanOfficerID', loanOfficerID)
  },
}

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchSuffixOption({ commit }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(`${appConfig.adminApiUri}master/getsuffixes`, {
        headers: headers,
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        alert(error)
      })
  },

  fetchUserRolesOption({ commit }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(`${appConfig.adminApiUri}master/getuserroles/2`, {
        headers: headers,
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        alert(error)
      })
  },
  resendEmailForLoanOfficer({ commit }, { userID, lastModifiedByUserID } = {}) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .post(
        appConfig.adminApiUri +
          'user/resend' +
          '?UserID=' +
          userID +
          '&LastModifiedByUserID=' +
          lastModifiedByUserID,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        alert(error)
      })
  },
  downloadLoanOfficerReport(
    { commit },
    { userID, pageSize, pageNumber, key, value } = {}
  ) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(
        `${appConfig.adminApiUri}loanofficer/download/${userID}?PageSize=${pageSize}&PageNumber=${pageNumber}&key=${key}&value=${value}`,
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = '\r\n' + response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'LoanOfficerReport.csv')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'LoanOfficerReport.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }

        return response
      })
  },
  storeLoanOfficerId({ commit }, { loanOfficerID } = {}) {
    commit('SET_LOANOFFICER_ID', loanOfficerID)
  },
  createLoanOfficer(
    { commit, dispatch, getters },
    {
      createdByUserID,
      lenderExternalID,
      salutation,
      firstName,
      middleName,
      lastName,
      suffix,
      email,
      mobile,
      role,
      meridianId,
      meridianPassword,
      isPrimary,
    } = {}
  ) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    var createLoanOfficerData = new FormData()
    createLoanOfficerData.append('CreatedByUserID', createdByUserID)
    createLoanOfficerData.append('LenderExternalID', lenderExternalID)
    createLoanOfficerData.append('SalutationID', salutation)
    createLoanOfficerData.append('FirstName', firstName)
    createLoanOfficerData.append('MiddleInitial', middleName)
    createLoanOfficerData.append('LastName', lastName)
    createLoanOfficerData.append('SuffixID', suffix)
    createLoanOfficerData.append('EmailAddress', email)
    createLoanOfficerData.append('PhoneNo', mobile)
    createLoanOfficerData.append('RoleID', role)
    createLoanOfficerData.append('MerdianLinkID', meridianId)
    createLoanOfficerData.append('MerdianLinkPassword', meridianPassword)
    createLoanOfficerData.append('IsPrimary', isPrimary)

    return axios
      .post(
        appConfig.adminApiUri + 'loanofficer/create/',
        createLoanOfficerData,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response.status === 409) {
          alert(error.response.data.message)
        }
      })
  },
  getTotalLoanOfficer(
    { commit, dispatch, getters },
    { lenderId, pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    var id = lenderId !== '' ? lenderId : state.lenderId
    var url =
      appConfig.adminApiUri +
      'loanofficer/getloanofficerstotalrecords/' +
      id +
      '?PageSize=' +
      pageSize +
      '&PageNumber=' +
      pageNumber +
      '&Key=' +
      key +
      '&Value=' +
      value +
      `&SortBy=${sortBy}&SortDirection=${sortDirection}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(url, {
        headers: headers,
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return error.Response.status
        }
        return error
      })
  },
  fetchLoanOfficersById({ commit }, { loanOfficerID } = {}) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(
        `${appConfig.adminApiUri}loanofficer/getloanofficerbyid/` +
          loanOfficerID,
        {
          headers: headers,
        }
      )
      .then((response) => {
        commit('SET_LOAN_OFFICER', response.data)

        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          commit('SET_LOAN_OFFICER', null)
        }
        return null
      })
  },
  getloanofficers(
    { commit, dispatch, getters },
    { lenderId, pageSize, pageNumber, key, value, sortBy, sortDirection }
  ) {
    var id = lenderId !== '' ? lenderId : state.lenderId
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }

    return axios
      .get(
        appConfig.adminApiUri +
          'loanofficer/getloanofficers/' +
          id +
          '?Pagesize=' +
          pageSize +
          '&PageNumber=' +
          pageNumber +
          '&key=' +
          key +
          '&value=' +
          value +
          `&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        alert(error)
      })
  },

  updateLoanOfficer({ commit, dispatch, getters }, { loanOfficerData }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }

    var updateLoanOfficerData = new FormData()
    updateLoanOfficerData.append('LoanOfficerID', loanOfficerData.loanOfficerID)
    updateLoanOfficerData.append('IsActive', loanOfficerData.isActive)
    updateLoanOfficerData.append(
      'LastModifiedByUserID',
      loanOfficerData.createdByUserId
    )
    updateLoanOfficerData.append(
      'LenderExternalID',
      loanOfficerData.lenderExternalID
    )
    updateLoanOfficerData.append('SalutationID', loanOfficerData.salutation)
    updateLoanOfficerData.append('FirstName', loanOfficerData.firstName)
    updateLoanOfficerData.append('MiddleInitial', loanOfficerData.middleName)
    updateLoanOfficerData.append('LastName', loanOfficerData.lastName)
    updateLoanOfficerData.append('SuffixID', loanOfficerData.suffix)
    updateLoanOfficerData.append('EmailAddress', loanOfficerData.email)
    updateLoanOfficerData.append('PhoneNo', loanOfficerData.mobileNumber)
    updateLoanOfficerData.append('RoleID', loanOfficerData.role)
    updateLoanOfficerData.append('MerdianLinkID', loanOfficerData.meridianId)
    updateLoanOfficerData.append(
      'MerdianLinkPassword',
      loanOfficerData.meridianPassword
    )
    updateLoanOfficerData.append('IsPrimary', loanOfficerData.isPrimary)

    return axios
      .post(
        appConfig.adminApiUri + 'loanofficer/update/',
        updateLoanOfficerData,
        {
          headers: headers,
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        alert(error)
      })
  },
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}

function getSavedLoanOfficerIDState(key) {
  if (window.localStorage['loanOfficers'] !== 'undefined')
    return JSON.parse(window.localStorage.getItem(key))
  else return null
}

function saveLoanOfficerId(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function getSavedLenderState(key) {
  if (window.localStorage['lenders'] !== 'undefined')
    return JSON.parse(window.localStorage.getItem(key))
  else return null
}
